const requestedAmountRanges = [
  {
    rows: [
      {
        title: '0-10000',
        id: 'RAR36',
        index: 36,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '10000-20000',
        id: 'RAR37',
        index: 37,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '20000-25000',
        id: 'RAR29',
        index: 38,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '25000-50000',
        id: 'RAR30',
        index: 39,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '50000-75000',
        id: 'RAR31',
        index: 40,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '75000-100000',
        id: 'RAR32',
        index: 41,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '100000-150000',
        id: 'RAR33',
        index: 42,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '150000-200000',
        id: 'RAR34',
        index: 43,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '200000-250000',
        id: 'RAR35',
        index: 44,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '250000-300000',
        id: 'RAR00',
        index: 45,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '300000-500000',
        id: 'RAR01',
        index: 10,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '500000-1000000',
        id: 'RAR02',
        index: 11,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '1000000-2000000',
        id: 'RAR03',
        index: 12,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '2000000-3000000',
        id: 'RAR04',
        index: 13,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '3000000-4000000',
        id: 'RAR18',
        index: 14,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '4000000-5000000',
        id: 'RAR14',
        index: 15,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '5000000-8000000',
        id: 'RAR19',
        index: 16,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '8000000-10000000',
        id: 'RAR05',
        index: 17,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '10000000-12000000',
        id: 'RAR06',
        index: 18,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '12000000-15000000',
        id: 'RAR20',
        index: 19,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '15000000-20000000',
        id: 'RAR15',
        index: 20,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '20000000-25000000',
        id: 'RAR07',
        index: 21,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '25000000-30000000',
        id: 'RAR21',
        index: 22,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      }
    ]
  },
  {
    rows: [
      {
        title: '30000000-40000000',
        id: 'RAR22',
        index: 21,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '40000000-50000000',
        id: 'RAR23',
        index: 22,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '50000000-60000000',
        id: 'RAR24',
        index: 23,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '60000000-75000000',
        id: 'RAR08',
        index: 24,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '75000000-80000000',
        id: 'RAR09',
        index: 25,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '80000000-100000000',
        id: 'RAR38',
        index: 26,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '100000000-150000000',
        id: 'RAR39',
        index: 26,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '150000000-200000000',
        id: 'RAR26',
        index: 27,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '200000000-250000000',
        id: 'RAR16',
        index: 28,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '250000000-300000000',
        id: 'RAR10',
        index: 29,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '300000000-350000000',
        id: 'RAR27',
        index: 30,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '350000000-400000000',
        id: 'RAR17',
        index: 31,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '400000000-500000000',
        id: 'RAR28',
        index: 32,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '500000000-1000000000',
        id: 'RAR11',
        index: 33,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '1000000000-2500000000',
        id: 'RAR12',
        index: 34,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      },
      {
        title: '2500000000-+ 2.500.000.000 €',
        id: 'RAR13',
        index: 35,
        color: '#1f497d',
        colorFilterValues: {
          invert: '21',
          sepia: '65',
          saturate: '1284',
          hueRotate: '189',
          brightness: '89',
          contrast: '86'
        }
      }
    ]
  }
]

export default requestedAmountRanges
